import { Box } from '@material-ui/core';
import { formatPercent } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../../../shared/components/Text';
import { TransactionsListRowProps } from '../../../types/TransactionsListRowProps';

export const vatRateFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.3,
    field: 'vat_rate',
    align: 'right',
    headerName: (
      <Box textAlign={'right'}>
        <Text tId={'VAT_RATE'} />
      </Box>
    ),
    renderCell: (rowData: TransactionsListRowProps) => {
      return (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              whiteSpace: 'break-spaces',
              lineHeight: '1.43',
            }}
          >
            <div className={'line-clamp-3'}>{formatPercent(rowData.row.vatRate)}</div>
          </div>
        </>
      );
    },
  };
};
